import { useEffect, useState } from 'react';

import { stickyBannerBottomSubject } from '@utils/blueconic/constants';
import { BlueconicStickyBannerBottomEvent } from '@utils/blueconic/eventsInterfaces';
import { BlueconicStickyBannerBottomProps } from '@utils/blueconic/propInterfaces';

const useBlueConicBottomStickyBannerDialogue = () => {
  const [blueConicProps, setBlueConicProps] = useState<
    BlueconicStickyBannerBottomProps | undefined
  >();

  useEffect(() => {
    const handleBlueconicEvent = (data: BlueconicStickyBannerBottomEvent) => {
      const {
        data: { title, buttonText, redirectUri, loggedInButtonText, dialogueType },
        variantId,
      } = data;
      setBlueConicProps({
        title,
        buttonText,
        redirectUri,
        loggedInButtonText,
        dialogueType,
        variantId,
      });
    };

    const subscription = stickyBannerBottomSubject.subscribe(handleBlueconicEvent);

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, []);

  return {
    blueConicProps,
  };
};

export default useBlueConicBottomStickyBannerDialogue;
